export default function withFlattenedProps(FieldComponent) {
  return (field) => {
    const { input, meta, ...custom } = field;

    return <FieldComponent {...input} formFieldMeta={meta} {...custom} />;
  };
}
